import Call from '../Call';

const ClickBaitMessages = {
    getPage(pageNum) {
        return Call(`clickBaitMessages/${pageNum}`);
    },

    save(message) {
        return Call(`clickBaitMessages`, 'POST', message);
    },

    update(messageID, message) {
        return Call(`clickBaitMessages/${messageID}`, 'PUT', message);
    },

    remove(messageID) {
        return Call(`clickBaitMessages/${messageID}`, 'DELETE');
    },

    sync() {
        return Call(`clickBaitMessages/sync`);
    }
};

export default ClickBaitMessages;


// WEBPACK FOOTER //
// ./src/services/API/components/ClickBaitMessages.js